import React from 'react';
import { Checkbox, FormControlLabel, Grid, Typography, withStyles } from '@material-ui/core';
import ValidationRule from './ValidationRule';
import MenuButton from './MenuButton/MenuButton';
import InfoHover from '../../../../controls/InfoHover';
import { createBlankRule, createEmailRule, createPhoneRule, createSsnRule, ruleOptions } from './defaultRules';

const styles = (theme) => ({
    section: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        background: '#F8F8F8',
        padding: theme.spacing(3),
    },
    emptyRule: {
        marginTop: theme.spacing(3),
    },
});

class Validation extends React.Component {
    state = {
        required: false,
        validationRules: [],
        ruleType: null,
    };

    componentDidMount() {
        this.setState({
            ...this.props.ruleData,
        });
    }

    changeValidation = (tag, value) => {
        this.setState({
            [tag]: value,
        });
        this.props.handleChange({
            validation: {
                ...this.state,
                [tag]: value,
            },
        });
    };

    handleSelectRuleOption = (ruleType) => {
        if (ruleType !== 'custom') {
            this.setState({
                ruleType: ruleType,
            });
        } else {
            this.addRule(ruleType);
        }
    };

    handleSelectFactOption = (factField) => {
        this.addRule(this.state.ruleType, factField);
        this.setState({
            ruleType: null,
        });
    };

    addRule = (ruleType, factField) => {
        switch (ruleType) {
            case 'custom':
                this.handleRuleChange(this.state.validationRules.length, createBlankRule());
                break;
            case 'email':
                this.handleRuleChange(this.state.validationRules.length, createEmailRule(factField));
                break;
            case 'phone':
                this.handleRuleChange(this.state.validationRules.length, createPhoneRule(factField));
                break;
            case 'ssn':
                this.handleRuleChange(this.state.validationRules.length, createSsnRule(factField));
                break;
            default:
                break;
        }
    };

    deleteRule = (index) => {
        const newValidationRules = [
            ...this.state.validationRules.slice(0, index),
            ...this.state.validationRules.slice(index + 1),
        ];
        this.changeValidation('validationRules', newValidationRules);
    };

    handleRequiredChange = (event) => {
        const tag = event.target.id;
        const value = event.target.checked;
        this.changeValidation(tag, value);
    };

    handleRuleChange = (index, newRule) => {
        const newValidationRules = [
            ...this.state.validationRules.slice(0, index),
            newRule,
            ...this.state.validationRules.slice(index + 1),
        ];
        this.changeValidation('validationRules', newValidationRules);
    };

    render() {
        const factFields = [this.props.field, ...this.props.entries];
        return (
            <React.Fragment>
                <div className={this.props.classes.section}>
                    <Typography variant="h6" gutterBottom>
                        Rules
                        <InfoHover
                            text={
                                'Add rules to ensure the field is filled out correctly. Include a message to inform the user that their response is not correct.'
                            }
                        />
                    </Typography>
                    <FormControlLabel
                        label={'This field is required'}
                        control={
                            <Checkbox
                                id={'required'}
                                name={'required'}
                                checked={this.state.required || false}
                                key={'required'}
                                color={'primary'}
                                onChange={(e) => this.handleRequiredChange(e)}
                            />
                        }
                    />
                </div>
                {!this.state.validationRules || this.state.validationRules.length === 0 ? (
                    <div className={this.props.classes.section}>
                        <Grid
                            container
                            direction="column"
                            alignItems="center"
                            justifyContent="center"
                            spacing={2}
                            xs={12}
                            className={this.props.classes.emptyRule}
                        >
                            <Grid item>
                                <Typography variant="body1">This field does not have any validation rules</Typography>
                            </Grid>
                            <Grid container alignItems="center" justifyContent="center">
                                <MenuButton
                                    title={`Add ${this.state.ruleType ? this.state.ruleType : 'a'} Rule`}
                                    options={ruleOptions}
                                    selectOption={this.handleSelectRuleOption}
                                />
                            </Grid>
                            <Grid container item alignItems="center" justifyContent="center">
                                {this.state.ruleType && (
                                    <MenuButton
                                        title={'Select a Fact'}
                                        options={factFields.map((field) => ({
                                            value: field.field,
                                            label: field.field,
                                        }))}
                                        selectOption={this.handleSelectFactOption}
                                    />
                                )}
                            </Grid>
                        </Grid>
                    </div>
                ) : (
                    <React.Fragment>
                        {this.state.validationRules.map((rule, index) => (
                            <div key={`rule${index}`} className={this.props.classes.section}>
                                <ValidationRule
                                    ruleInfo={rule}
                                    index={index}
                                    entries={[this.props.field, ...this.props.entries]}
                                    handleRuleChange={this.handleRuleChange}
                                    deleteRule={this.deleteRule}
                                />
                            </div>
                        ))}
                        <div className={this.props.classes.section}>
                            <Grid
                                container
                                direction="column"
                                alignItems="center"
                                justifyContent="center"
                                spacing={2}
                                xs={12}
                                className={this.props.classes.emptyRule}
                            >
                                <Grid container item alignItems="center" justifyContent="center">
                                    <MenuButton
                                        title={`Add ${this.state.ruleType ? this.state.ruleType : 'new'} Rule`}
                                        options={ruleOptions}
                                        selectOption={this.handleSelectRuleOption}
                                    />
                                </Grid>
                                <Grid container item alignItems="center" justifyContent="center">
                                    {this.state.ruleType && (
                                        <MenuButton
                                            title={'Select a Fact'}
                                            options={factFields.map((field) => ({
                                                value: field.field,
                                                label: field.field,
                                            }))}
                                            selectOption={this.handleSelectFactOption}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        </div>
                    </React.Fragment>
                )}
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(Validation);
